.section {
  margin-top: var(--tuna-spacing-3);
}

.title {
  margin-bottom: 4px;
}

.title:focus-visible {
  outline: 2px solid var(--tuna-focus-ring);
  outline-offset: 2px;
}

.part {
  margin-bottom: var(--tuna-spacing-2);
}

.partTitle {
  margin-bottom: 4px;
}

/* 44px rows: touch targets for the radios and the checklist (spec, Mobile) */
.choice {
  min-height: 44px;
}

.checklist {
  margin: var(--tuna-spacing-1) 0 0;
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  display: flex;
  flex-direction: column;
}

.legend {
  padding: 0 4px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}
